<template>
  <v-snackbar
    v-model="show"
    :timeout="snackbar.duration ?? 8000"
    :color="snackbar.color ?? 'surface'"
    :location="snackbar.location ?? 'bottom'"
  >
    <div v-if="typeof snackbar.message === 'string'">
      {{ snackbar.message }}
    </div>
    <div v-else>
      <component :is="snackbar.message" />
    </div>
    <template #actions>
      <div class="d-flex justify-space around align-center">
        <v-btn
          v-if="snackbar.action"
          class="text-uppercase"
          variant="text"
          min-width="70"
          @click="handleAction"
        >
          {{ snackbar.action.text }}
        </v-btn>
        <v-btn
          icon="mdi-close"
          size="x-small"
          variant="text"
          style="margin-bottom: 2px;"
          @click="closeSnack"
        />
      </div>
    </template>
  </v-snackbar>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

export default {
  name: 'MessageSnackbar',
  data() {
    return {
      show: true,
    };
  },
  computed: {
    ...mapState(['snackbar']),
  },
  watch: {
    snackbar(newVal) {
      this.show = !!newVal;
    },
  },
  methods: {
    ...mapMutations(['setSnack']),
    async handleAction() {
      const {action} = this.snackbar;
      await action.callback();
      // Closing now would clear the message the action put in this one's place.
      if (action.setsNextSnack) return;
      this.closeSnack();
    },
    closeSnack() {
      this.snackbar?.closeCallback?.();
      this.setSnack(null);
      this.show = false;
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.v-snackbar__content) {
  display: flex;
  align-items: center;
  padding-top: 16px;
}
:deep(.v-snackbar__actions) {
  height: 50px;
  margin-inline-end: unset;
}
</style>
